<template>
  <div class="kjxj-con">
    <div class="kjxj-list">
      <div class="kjxj-item" v-for="item,ind in kcjsList" :key="ind" @click="toDetail(item)">
        <div class="item-img">
          <div :style="`background-image: url(${item.cover})`"></div>
        </div>
        <div class="item-info">
          <div class="item-title" >{{item.title}}</div>
        </div>
      </div>
      <div class="bnkj-empty"></div>
      <div class="bnkj-empty"></div>
    </div>
    <div v-if="pageNum > 1" class="pagination">
      <a-pagination v-model="page" :total="total" :page-size="pageSize" @change="onPagesChange" size="small" :item-render="itemRender" />
    </div>
    <div v-else-if="kcjsList.length <= 0" class="noData-box">
      <img src="../../../../assets/image/jsckzyxy/empty.png" alt="" />
      <div class="text">暂无相关内容</div>
    </div>
    <div class="spin-con" v-if="loading">
      <a-spin>
        <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
      </a-spin>
    </div>

  </div>
</template>

<script>
import services from "../../../../assets/js/services.js";
import { mapActions } from "vuex";
import utils from "../../../../assets/js/utils.js";


export default {
  props: {
    activeObj: {
      type: Object,
      default: () => { }
    }
  },

  data() {
    return {
      school_code: localStorage.getItem("schoolCode"),
      specialId: services.KJQG_SPECIAL_ID,
      kcjsList: [],
      page: 1,
      total: 0,
      pageSize: 12,
      pageNum: 0,
      loading: false,
      videoShow: false,
      videoInfo: {}
      //   activeCategroy: ""
    }
  },
  watch: {
    activeObj: {
      handler(newVal) {
        // this.activeCategroy = newVal.children[0].title
        this.page = 1
        this.getkjhzList()
      },
      immediate: true,
    }
  },
  methods: {
    ...mapActions(["goAppsDetailsBeforeLogin", "getAppsLoginUserInfo"]),
    async getkjhzList() {
      this.loading = true;
      let res = await services.getAreaSzztkLists({
        page: this.page,
        length: this.pageSize,
        count: 0,
        school_code: this.school_code,
        special_id: this.specialId,
        kind: "1",
        column_name: this.activeObj.title,
        order_by: "asc"
      });
      if (res.code == "0000" && res.data.items.length > 0) {
        this.kcjsList = res.data.items
        this.pageNum = res.data.page_num;
        this.total = res.data.total;
      } else {
        this.kcjsList = [];
        this.pageNum = 0;
        this.total = 0;
      }
      this.loading = false;

    },
    setActiveTit(item) {
      this.activeCategroy = item.title
      this.page = 1;
      this.getkjhzList();
    },
    onPagesChange(val) {
      this.page = val;
      this.getkjhzList();
    },
    itemRender(current, type, originalElement) {
      if (type === "prev") {
        return <a>上一页</a>;
      } else if (type === "next") {
        return <a>下一页</a>;
      }
      return originalElement;
    },
    toDetail(item) {
      if (item) {
        this.goAppsDetailsBeforeLogin().then(() => {
          this.$router.push({
            path: `/${this.school_code}/kjqg/detail`,
            query: {
              id: item.id,
              column_id: item.column_id,
              columnPath: "kcjsgm",
            },
          });
        });
      }
    },

  }
}
</script>

<style lang="less" scoped>
.kjxj-con {
  .kjxj-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .kjxj-item {
      width: 272px;
      height: 204px;
      position: relative;
      border: #1869e4 1px solid;
      margin-bottom: 32px;
      cursor: pointer;
      .item-img {
        width: 100%;
        height: 100%;
        overflow: hidden;
        div {
          background-size: cover;
          background-position: center;
          width: 100%;
          height: 100%;
          transition: all 0.3s;
        }
      }
      .item-info {
        width: 100%;
        position: absolute;
        bottom: 0;
        // height: 120px;
        background: linear-gradient(
          180deg,
          rgba(30, 91, 241, 0) 0%,
          #1e5bf1 100%
        );
        padding: 27px 17px 10px;
        position: absolute;
        bottom: 0;
        .item-title {
          font-weight: 400;
          font-size: 14px;
          color: #ffffff;
          margin-bottom: 2px;
          &:first-child {
            font-weight: bold;
            font-size: 18px;
            color: #ffffff;
            margin-bottom: 5px;
          }
        }
      }
      &:hover {
        .item-img {
          div {
            transform: scale(1.1);
          }
        }
      }
    }
    .bnkj-empty {
      width: 272px;
    }
  }
  .pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    margin-top: 45px;
    z-index: 2;
    ::v-deep.ant-pagination {
      .ant-pagination-prev,
      .ant-pagination-next {
        margin: 0 15px;
        a {
          color: #1869e4;
        }
      }
      .ant-pagination-item {
        margin: 0 5px;
        border-radius: 0;
        a {
          color: #1869e4;
        }
        &.ant-pagination-item-active {
          background-color: #1869e4;
          border: 1px solid transparent;
          a {
            color: #fff;
          }
        }
      }
    }
  }
}
.spin-con {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  top: 0;
  z-index: 999;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>